<template>
  <div id="app">
    <call-amap-bar
      ref="callAmapBar"
      :schema="callSchema"
      :pageType="page_type"
      v-if="!isInAmap"
      @openAmapLog="openAmapLog"
      @goAmap="callAmap"></call-amap-bar>
    <div
      class="content-wrap"
      ref="contentWrap"
      :class="{ 'content-in': isInAmap, 'content-out': !isInAmap}"
    >
      <title-comp
        ref="titllCome"
        v-if="pageType === 0"
        :title-obj="titleObj"
        :title-type="titleType"
        :logParams="logParams"
      ></title-comp>
      <!-- 天气卡片组件 -->
      <Weather
        class="weather-box"
        :weather="weather"
        v-if="isShowWeather"
      ></Weather>
      <!-- v-html="richText" -->
      <Notification></Notification>
      <div
        class="push-content"
        :class="{ 'text-mode': pageType === 0, 'preview-mode': pageType === 1 }"
        ref="pushContent"
        v-html="richText"
      ></div>
      <div
        v-if="extFunc === 2"
        style="padding: 0 0.16rem; flex-shrink: 1; margin-top: 0.4rem"
      >
        <CongestionSituation
          v-if="realTimeData && congestDataList.length"
          :showMap="mapLoaded"
          :real-time-data="realTimeData"
          :congest-data-list="congestDataList"
          :congest-data-inited="congestDataInited"
          :area-type="areaType"
          :update-time="updateTime"
          :city-adcode="cityAdcode"
          :unit-id="unitId"
          :logParams="logParams"
        />
        <TrafficForecast
          v-if="(areaType === 0 || areaType === 2) && predictData"
          :predict-data="predictData"
          :city-name="cityName"
          :unit-id="unitId"
          :logParams="logParams"
        />
      </div>

      <Banner :page-type="pageType" v-if="isInAmap && canShowAd"></Banner>
      <Qrcode v-if="isInWeixin" />
      <img-preview
        :imgUrls="imgUrlArr"
        :currentIndex="currentIndex"
        v-if="showImgPreview"
        v-on:closeImagePopup="handleImgPreviewClose"
      ></img-preview>
      <hot-news-list
        v-if="newsList && newsList.length" :newsList="newsList" :categoryList="categoryList" />
      <div class="push-footer" v-if="pageType === 0"></div>
      <transition name="fade">
        <hover-dot
          :link-audio="currentShowAudio"
          v-if="currentShowAudio"
        ></hover-dot>
      </transition>
      <!-- 引导弹窗 -->
      <GuideOpenTag
        :id="id"
        :schema="callSchema"
        :pageType="page_type"
        v-if="showGuideOpenTag"
        @close="modalCloseGuideOpenTag"
        @openAmapLog="openAmapLog"
        @goAmap="callAmap"
      ></GuideOpenTag>
    </div>
    <!-- 唤端按钮 -->
     <call-amap-btn
      :schema="callSchema"
      :pageType="page_type"
      v-if="!isInAmap"
      @openAmapLog="openAmapLog"
      @goAmap="callAmap"
    ></call-amap-btn>
    <div
      :class="{
        'info-scence-window': true,
        'info-scence-window-active': infoScenceWindowRes,
        'animation-apear': infoScenceWindowRes,
      }"
      @click="openInfoScenceWindow"
    >
      <div class="title-container">
        <div class="title-common-style  main-title">
          {{ infoScenceWindowRes? infoScenceWindowRes.material[0].text.title:'' }}
        </div>
        <div class="title-common-style  sub-title">
          {{ infoScenceWindowRes? infoScenceWindowRes.material[0].text.short_title:'' }}
        </div>
      </div>
      <button class="btn">
        {{ infoScenceWindowRes? infoScenceWindowRes.material[0].button.button_text:'' }}
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, camelcase, prefer-destructuring */
import {
  bridge, os, loader as http, util, webviewInfo, native, log
} from '@ali/amap-lib';

import Monitor from '@ali/act-monitor';
import schemaHandle from '@ali/amap-call-native/schemaHandle';
import callNative from '@ali/amap-call-native/callNative';
import getShareLogParams from '@ali/amap-call-native/getShareLogParams';
import wxOpen from '@ali/amap-call-native/wxOpen';
import dayjs from 'dayjs';
import api from '../../../config/config.aos';
import jumpHandler from '../../../common/js/jump-handler';
// import Adu from '../js/audio';
import Map from '../js/Map';
// import HoverAudio from './hoverAudio.vue';
import TitleComp from './Title.vue';
import Banner from './tianqingAd/Banner.vue';
import ImgPreview from './ImgPreview.vue';
import CallAmapBar from './CallAmapBar.vue';
import CallAmapBtn from './CallAmapBtn.vue';
// import Share from '../../../common/js/Share';
import linkurl from '../../../config/config.url';
import toast from '../../../common/js/modules/toast';
import immersive from '../../../common/js/immersive';
import MsgBox from '../../../common/js/msgbox';
import $ from '../../../common/js/zepto';
import HoverDot from './HoverDot.vue';
// import callNative from '../../../common/js/call-native';
// import nav from '../../../common/js/open-amap';
import service from '../../../common/js/service-handle';
import configShare from '../../../config/config.share'; // 默认二次分享兜底文案
// 天气卡片类型
import Weather from './weather/Weather.vue';
import weatherMixin from './weather/mixin';
// 交通号类型
import CongestionSituation from './jiaotonghao/situation/CongestionSituation.vue';
import TrafficForecast from './jiaotonghao/forecast/TrafficForecast.vue';
import Notification from './Notification.vue';
import trafficMixin from './jiaotonghao/mixin';
// 微信公众号二维码
import Qrcode from './weixinQrcode/qrcode.vue';
import GuideOpenTag from './GuideOpenTag.vue';
import HotNewsList from './HotNewsList/HotNewsList.vue';
import AesMonitor, { blankPluginParams } from '../../../common/js/monitor';
// 呼气规则
// import callRules from '../../../config/default.call.rules.config';

const { YKU } = window;
let initBlankPlugin = true;

export default {
  name: 'app',
  mixins: [weatherMixin, trafficMixin],
  components: {
    Notification,
    // HoverAudio,
    TitleComp,
    Banner,
    ImgPreview,
    CallAmapBar,
    CallAmapBtn,
    HoverDot,
    Weather,
    CongestionSituation,
    TrafficForecast,
    Qrcode,
    GuideOpenTag,
    HotNewsList,
  },
  data() {
    return {
      callSchema: null,
      pageType: 1, // 图文模式
      titleData: { title: '高德地图', color: '#616161' },
      titleType: 1, // 标题种类
      titleObj: null,
      richText: '', // 富文本
      os,
      audioCompArr: [], // audio组件数组
      videoCompArr: [], // video组件数组
      mapCompArr: [], // 地图组件数组
      imgUrlArr: [], // 图片资源数组
      currentIndex: 0, // 点击第几张图片
      currentShowAudio: null, // 当前需要展示固底的audio
      showImgPreview: false, // 是否显示图片预览
      clickTimer: true, // 防连点
      isInAmap: webviewInfo.isInAmap(),
      isInWeixin: webviewInfo.isInWeixin(),
      // isInAmap: false,
      lastClickAudio: null,
      weaknetTimer: null, // 音频定时器
      id: '', // 文章id
      adcode: '',
      canShowAd: false,
      shareConfig: null, // 分享配置
      share: null, // 分享实例
      checkInterval: null,
      isLogged: false,
      tid: '',
      adiu: '',
      extFunc: 0, // 卡片类型，0普通，1天气，2交通号
      logParams: {}, // 埋点参数
      share_from: window.location.origin + window.location.pathname,
      share_channelSpm: 'amap.2019_push_template.call.call_amap',
      o_b_p: '', // 端外业务参数区分不同文章的唤端率
      page_type: 'push_template',
      showGuideOpenTag: false, // 展示唤端引导弹窗
      newsList: [], // 热门文章推荐列表
      categoryList: [], // 文章分类列表
      readArticles: '', // 服务请求已读文章
      infoScenceWindowRes: undefined,
    };
  },
  async created() {
    const params = getShareLogParams({
      page_type: this.page_type
    });
    console.log(params, '=====埋点全链路参数');
    // eslint-disable-next-line no-undef
    window?.AmapTracker?.sendPV({
      spmB: '2019_push_template', // 业务自己申请的spmB
      params,
    });
  },
  async mounted() {
    const params = getShareLogParams({
      page_type: this.page_type
    });
    this.id = util.getUrlParam('id');
    this.contentCategory = util.getUrlParam('contentCategory') || '';
    this.from = util.getUrlParam('from') || '';
    if (this.id) {
      this.o_b_p = encodeURIComponent(JSON.stringify({
        call_log_id: `push_${this.id}`,
      }));
    }
    if (!this.isInAmap) { // 曝光端外才埋点
      // eslint-disable-next-line no-undef
      window?.AmapTracker?.recordCLK('amap.Amap_share.0.page_view', {
        params: {
          ...params,
          o_b_p: this.o_b_p, // 端外
        },
      });
      const { contentWrap } = this.$refs;
      const innerHeight = window.innerHeight || document.documentElement.clientHeight;
      if (contentWrap) {
        contentWrap.style.height = `${innerHeight - 100}px`;
      }
    }
    const apiver = util.getUrlParam('apiver');
    this.callSchema = `${schemaHandle(`${linkurl.index}?id=${this.id}&contentCategory=${this.contentCategory}&from=${this.from}&share_channelSpm=${this.share_channelSpm}&apiver=${apiver}`, { showTitleBar: true, page_type: this.page_type })}&share_channelSpm=${this.share_channelSpm}&o_b_p=${this.o_b_p}&sourceApplication=push_content_page&gd_from=outAmap&whiteList=amap.com&keepStack=1&clearStack=0`;
    if (+os.version <= 4.3 && !os.harmony) {
      MsgBox({
        content: '您的App版本过低，请升级后再试', // 提示文案
        tips: '', // 小字提示文案
        hasClose: false, // 默认没有关闭按钮
        closeFun: null, // 点击关闭按钮触发的方法
        btns: [
          // msgbox按钮列表，可以多个按钮
          {
            text: '确认', // 按钮文案
            fun: native.webviewGoBack, // 点击按钮触发的方法
            noClose: false // 是否不需要关闭弹窗，默认（false）需要关闭
          }
        ]
      });
      return;
    }

    if (this.isInAmap) {
      log.initLog('activity_2019_pushwork_main');
      const appInfo = await this.getVersion().catch(() => '');
      console.log('appInfo', appInfo);
      this.tid = appInfo.tid;
      this.adiu = appInfo.adiu;
      this.diu = appInfo.diu;
      console.log('[时间]', dayjs().format('YYYY-MM-DD'));
      const isLogged = await service.getUserId(true, false).catch((error) => {
        console.log(error);
      });
      this.isLogged = isLogged;
    } else {
      log.initLog('activity_2019_pushwork_wx');
    }
    // log.initLog('activity_2019_pushwork_main');
    this.buryingPoint();
    await this.getPushContent();
    await this.handleArticleData();
    this.infoSceneWindow();
  },
  beforeDestroy() {
    native.destroyRightButton(() => {});
  },
  methods: {
    openInfoScenceWindow() {
      log.log('push_click', { creative_id: this.infoScenceWindowRes.creative_id });
      const url = this.infoScenceWindowRes.action_config.h5 || this.infoScenceWindowRes.action_config.schema;
      console.log('openInfoScenceWindow', url);
      jumpHandler(url, {
        delay: 0,
        hideTitleBar: false,
        needSchema: true,
      });
      this.infoScenceWindowRes = undefined;
    },
    async infoSceneWindow() {
      const cid = util.getUrlParam('cid') || '';
      const amsfrom = util.getUrlParam('amsfrom') || '';
      if (cid && amsfrom === 'push') {
        const { div, adiu } = this.$root.appInfo;
        if (fetch) {
          const url = window.location.hostname === 'cache.gaode.com'
            ? 'https://amap-rta-online-defalut.amap.com/admerger/info_scene_window'
            : 'https://gray-amap-rta-online.amap.com/admerger/info_scene_window';
          const params = {
            div,
            adiu,
            content_category: cid,
            adcode: this.userLocation?.adcode,
            ad_source: 'info_scene_window',
          };
          console.log('端push消息获取参数', params);
          const query = new URLSearchParams(params).toString();
          fetch(`${url}?${query}`)
            .then((res) => res.json())
            .then((res) => {
              console.log('端push消息获取', res);
              this.infoScenceWindowRes = res?.data?.info_scene_window[0];
              log.log('push_pv', { creative_id: this.infoScenceWindowRes.creative_id });
              const timer = setTimeout(() => {
                this.infoScenceWindowRes = undefined;
                clearTimeout(timer);
              }, 3000);
            })
            .catch((err) => console.error('端push消息获取失败', err));
        } else {
          console.error('端push消息获取失败:fetch 不可用');
        }
      } else {
        console.error(`端push消息获取失败:cid=${cid},amsfrom=${amsfrom}`);
      }
    },
    async handleArticleData() {
      if (!this.isInAmap) return false;
      const storageResult = await service.getLocalStorage().catch(() => false);
      try {
        const articleArr = (storageResult && JSON.parse(storageResult)) || [];
        if (Array.isArray(articleArr)) {
          this.singleArticleArr = Array.from(new Set(articleArr));
          this.singleArticleArr.forEach((item) => {
            this.readArticles += !this.readArticles
              ? `${item.value}`
              : `,${item.value}`;
          });
          console.log('readArticles', this.readArticles);
        }
      } catch (e) {
        console.log(e);
      }
      this.userLocation = await service.getMapLocationNew().catch(() => false);
      this.getArticlesData();
    },
    async twiceShare() {
      await wxOpen();
      if (webviewInfo.isInWeixin()) {
        window.addEventListener('wx.ready', async () => {
          const {
            title, message, imgUrl, url
          } = this.shareConfig || {};
          console.log('----', this.shareConfig);
          const data = {
            title: title || configShare.title,
            desc: message || configShare.desc,
            imgUrl: imgUrl || configShare.imgUrl,
            link: url || window.location.href,
            url: url || window.location.href,
          };
          const {
            updateAppMessageShareData,
            onMenuShareAppMessage,
            updateTimelineShareData,
            onMenuShareTimeline,
          } = window.wx || {};

          console.log('二次 share----', data, window.wx);

          if (updateAppMessageShareData) {
            updateAppMessageShareData(data);
          } else if (onMenuShareAppMessage) {
            onMenuShareAppMessage(data);
          }

          if (updateTimelineShareData) {
            updateTimelineShareData(data);
          } else if (onMenuShareTimeline) {
            onMenuShareTimeline(data);
          }
        });
      }
    },
    getUuid(adiu = '') {
      if (!adiu) {
        console.error('adiu必传');
      }
      const uuid = adiu.split('');
      const ts = Date.now();
      // 时间戳转32进制，变短
      const ts32 = ts.toString(32);
      // 把时间戳倒序插入到adiu中，避免明文adiu安全风险
      const indexes = ts.toString().slice(-1 * ts32.length).split('').reverse();
      let cursor = 0;
      for (let i = 0; i < indexes.length; i++) {
        cursor += Number(indexes[i]);
        uuid.splice(cursor % adiu.length, 0, ts32[i]);
      }
      return uuid.join('');
    },
    getVersion() {
      return new Promise((resolve) => {
        native.getAppInfo((res) => {
          resolve(res);
        });
      });
    },
    openAmapLog(type) {
      if (type === 'opentag' && this.showGuideOpenTag) {
        this.showGuideOpenTag = false;
      }
      const params = getShareLogParams({
        page_type: this.page_type
      });
      console.log(params, '点击=====埋点全链路参数');
      // eslint-disable-next-line no-undef
      window?.AmapTracker?.recordCLK('amap.Amap_share.0.call_Amap_click', {
        params: {
          ...params,
          o_b_p: this.o_b_p, // 端外
        },
      });
      // eslint-disable-next-line no-undef
      window?.AmapTracker?.recordCLK('call.call_amap', {
        params: {
          ...params,
          share_channelSpm: this.share_channelSpm,
          o_b_p: this.o_b_p, // 端外
        },
      });
    },
    modalCloseGuideOpenTag() {
      this.showGuideOpenTag = false;
    },
    callAmap() {
      this.openAmapLog(); // 埋点
      const schema = `${this.callSchema}`;
      console.log('最终schema', schema);
      // const { auto } = callRules;
      // await callNative.call(auto, schema, {});
      setTimeout(async () => {
        await callNative(schema, null, {}).catch((err) => {
          console.log('呼起异常', err);
        });
      }, 10);
    },
    goAmap(isFromTop = false) {
      // this.showGuideOpenTag = true;
      if (!webviewInfo.isInAmap()) {
        const self = this;

        if (webviewInfo.isInWeixin()) {
          if (os.ios) {
            this.callAmap();
            setTimeout(() => {
              // console.log(document.visibilityState);
              if (document.visibilityState === 'hidden') {
                log.log('B003', {
                  type: self.id,
                  other: isFromTop ? 2 : 1
                });
              }
            }, 3000);
          } else if (os.android) {
            // if (isFromTop) {
            //   this.callAmap();
            // } else {
            //   this.showGuideOpenTag = true;
            // }
            // MsgBox({
            //   content: '打开高德地图查看原文',
            //   tips: '',
            //   hasClose: false,
            //   closeFun: null,
            //   btns: [
            //     {
            //       text: '取消',
            //       fun() {
            //         log.log('B002', {
            //           type: self.id,
            //           other: isFromTop ? 2 : 1
            //         });
            //       }
            //     },
            //     // msgbox按钮列表，可以多个按钮
            //     {
            //       text: '继续', // 按钮文案
            //       fun() {
            //         callFn();
            //         log.log('B001', {
            //           type: self.id,
            //           other: isFromTop ? 2 : 1
            //         });
            //       },
            //       noClose: false // 是否不需要关闭弹窗，默认（false）需要关闭
            //     }
            //   ]
            // });
          }
        }
      }
    },

    // 获取落地页内容
    getPushContent() {
      // 判断 url 参数 apiver 是否为 2，决定使用哪个接口
      const apiver = Number(util.getUrlParam('apiver'));
      const isInAmap = webviewInfo.isInAmap();
      const isApiV2 = apiver === 2;

      // 根据 apiver 决定接口地址和请求配置
      const apiUrl = isApiV2 ? api.push_detail : api.detail;

      // 根据环境和版本决定请求方法
      let request;
      if (isInAmap) {
        request = isApiV2 ? http.get : http.post;
      } else {
        request = http.jsonp;
      }

      // 根据 apiver 决定请求参数
      const params = isApiV2
        ? [{ adiu: this.adiu, sign: 1 }, { id: this.id }]
        : [{ ts: Math.floor(Date.now() / 1000), sign: 1 }, { id: this.id, sign: 1 }];

      request(
        apiUrl,
        params,
        (res) => {
          console.log('result', res, apiUrl);
          if (+res.code === 1) {
            const { data } = res;
            this.id = data.id;
            this.pageType = +data.image_text_type;
            this.titleType = data.title_type;
            this.titleObj = {
              title: data.title,
              push_user: data.push_user,
              push_time: data.push_time,
              viewed_count: data.viewed_count,
              title_image: data.title_image
            };
            this.extFunc = Number(data.ext_func);
            // ext_func:1 天气类型卡片
            if (this.extFunc === 1) {
              this.getWeatherAosData();
            }
            // ext_func:2 交通号卡片
            if (this.extFunc === 2) {
              const info = JSON.parse(data.ext_data) || {};
              const { minPicUrl, nickName } = info;
              this.getUnitData(info);
              this.$set(this.logParams, 'pageType', this.extFunc);
              this.$set(this.logParams, 'type', this.id);
              this.$set(this.logParams, 'unitId', info.unitId);
              if (minPicUrl) {
                this.$set(this.titleObj, 'min_image', minPicUrl);
              }
              if (nickName) {
                this.$set(this.titleObj, 'push_user', nickName);
              }
              // 交通号埋点需求
              const script = document.createElement('script');
              script.type = 'text/javascript';
              script.id = 'beacon-aplus';
              script.setAttribute('exparams', 'clog=o&aplus&sidx=aplusSidx&ckx=aplusCkx');
              script.src = 'https://g.alicdn.com/alilog/mlog/aplus_v2.js';
              console.log('script', script);
              document.body.appendChild(script);
              // 加载地图内容
              this.loadMap();
            }

            log.log('pv', {
              page_type: this.extFunc,
              type: this.id,
              islogin: this.isLogged ? 1 : 0
            });

            // const share = new Share();
            // this.share = share;
            const url = new URL(linkurl.index + window.location.search);
            const currentHost = window.wxHost?.host || window.location.host;
            url.host = currentHost;
            this.shareConfig = {
              title: data.weixin_share_title,
              message: data.share_text,
              imgUrl: data.share_image,
              url: url.href
            };
            // 端内且不是天气卡片类型（天气卡片到了action不能端外访问）
            if (webviewInfo.isInAmap() && Number(data.ext_func) !== 1) {
              // 设置titlebar名称
              native.setWebViewTitle(data.title_bar || '高德地图');
              if (window.AmapTracker) {
                const spmC = 'share'; // 区块自定义,比如顶部分享取名titlebar,底部按钮取名button
                const spmD = 'share_entrance'; // 约定写死
                window.AmapTracker.recordEXP(`${spmC}.${spmD}`); // recordEXP
              }
              // 注册分享按钮
              native.registRightButton('share', '分享', () => {
                log.log('share', { type: this.id });
                if (window.AmapTracker) {
                  const spmC = 'share'; // 区块自定义,比如顶部分享取名titlebar,底部按钮取名button
                  const spmD = 'share_entrance'; // 约定写死
                  window.AmapTracker.recordCLK(`${spmC}.${spmD}`);
                }
                this.setShare();
              });
            } else {
              this.twiceShare();
            }
            this.richText = data.body;
            // this.richText = "<p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><div class='audio-comp' data-src='http://sc1.111ttt.cn:8282/2018/1/03m/13/396131203208.m4a?tflag=1546606800&pin=97bb2268ae26c20fe093fd5b0f04be80#.mp3' data-name='一路向北' data-author='周杰伦' data-icon='https://gw.alicdn.com/tfs/TB1l1zhVQzoK1RjSZFlXXai4VXa-232-204.png'></div><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p><p>十来块打飞烧开后对方</p>";
            this.$nextTick(() => {
              // Monitor.log({
              //   type: 'contentLoaded',
              //   page_type: this.extFunc,
              //   id: this.id,
              // });
              setTimeout(() => {
                this.canShowAd = true;
                this.$nextTick(() => {
                  setTimeout(() => {
                    const bodyHeight = $('#app').height();
                    if (bodyHeight < 800) return;
                    console.log('【页面总高度】', bodyHeight);
                    const domHeightArray = [];
                    $('p').forEach((item) => {
                      if ($(item).offset().top > 800) {
                        domHeightArray.push(item);
                      }
                    });
                    // console.log('[domHeightArray]', domHeightArray);
                    const dom = $('.zxs-banner');
                    if (domHeightArray[0] && dom) {
                      // console.log($(domHeightArray[0]).html());
                      $(domHeightArray[0]).after(dom);
                    }
                  }, 300);
                });
              }, 300);
              $('a').forEach((item) => {
                if ($(item).has('img').length !== 0) {
                  $(item).addClass('noLinkIcon');
                }
              });
              $('.img-inline img').forEach((item) => {
                $(item).removeAttr('style');
                $(item).removeAttr('width');
                $(item).removeAttr('height');
              });
              $('.style-defined-wrap').each((i, ele) => {
                const url = ele.getAttribute('data-url');
                const iosSchema = ele.getAttribute('data-iosschema');
                const androidSchema = ele.getAttribute('data-androidschema');
                if (url || iosSchema || androidSchema) {
                  ele.addEventListener('click', () => {
                    if (url && this.clickTimer) {
                      this.clickTimer = false;
                      this.loadUrl(false, url);
                      setTimeout(() => {
                        this.clickTimer = true;
                      }, 300);
                    } else if ((iosSchema || androidSchema) && this.clickTimer) {
                      this.clickTimer = false;
                      this.loadUrl(true, os.ios ? iosSchema : androidSchema);
                      setTimeout(() => {
                        this.clickTimer = true;
                      }, 300);
                    }
                  });
                }
              });
              this.bindEvent();
              this.generateAudioEle();
              this.setVideoHeight();
              this.generateMap();
              this.addPageListener();
              // this.addPageScrollListener();
              this.getImgArrBindEvent();
            });
          } else {
            toast('页面好像出错了呢！');
          }
          this.goAmap();
          try {
            // 白屏检测
            if (initBlankPlugin) {
              AesMonitor.sendBlank(blankPluginParams);
              initBlankPlugin = false;
            }
          } catch (error) {
            console.log('白屏检测失败', error);
          }
        }
      );
    },
    /**
     * 获取热门文章推荐数据
     * 少于3条不展示此模块
     */
    async getArticlesData() {
      const result = await service.articleList({
        diu: this.diu,
        adiu: this.adiu,
        contentCategory: this.contentCategory,
        black_adgroups: this.readArticles,
        from: this.from,
        userLocation: this.userLocation || {}
      }).catch(() => false);
      if (!result) {
        return;
      }

      const { msgs = [], category_list: categoryList } = result;
      // msgs有可能为null；增加兼容性；
      const data = msgs?.map((item) => {
        if (item.type === 'graphics_new' && item.msg) {
          return {
            ...item.msg,
            showTitle: item.msg?.material?.[0]?.text?.title || '',
            showImage: item.msg?.material?.[0]?.image?.urls?.[0] || item.msg?.material?.[0]?.image?.url || '',
          };
        }
      });
      if (data?.length >= 3) {
        this.newsList = data.slice(0, 3);
        this.categoryList = categoryList || [];
      }
    },
    // 设置视频元素高度
    setVideoHeight() {
      // const docEl = document.documentElement;
      // const standardRetail = docEl.clientWidth / docEl.clientHeight;
      const standardRetail = 0.5625;
      const container = this.$refs.pushContent;
      const containerWidth = container.clientWidth;
      const videoEleArr = Array.from(container.querySelectorAll('.video-comp'));
      this.videoCompArr = videoEleArr.map((videoEle, index) => {
        videoEle.style.height = `${Number.parseInt(containerWidth * standardRetail, 10)}px`;
        return {
          dom: videoEle,
          video: this.initVideo(`video-comp${index + 1}`, videoEle)
        };
      });
      console.log(this.videoCompArr);
      this.addAudioplayListener();
    },
    // 初始化视频
    initVideo(eleid, videoEle) {
      const client_id = videoEle.getAttribute('data-clientid');
      const vid = videoEle.getAttribute('data-vid');
      const self = this;
      const videoTimer = setTimeout(() => {
        toast('网络不好，请稍后重试');
      }, 10000);
      return new YKU.Player(eleid, {
        styleid: '0',
        client_id,
        vid,
        newPlayer: true,
        events: {
          onPlayStart() {
            // 播放视频时检查是否有正在播放的音频并暂停音频
            self.chechPlayingAudio();
            const ele = videoEle.querySelector('.x-pilot-btn');
            ele.addEventListener('click', () => {
              native.destroyRightButton(() => {});
            });
          },
          onPlay() {
            log.log('video', { other: vid, type: this.id });
            self.chechPlayingAudio();
          },
          onPause() {
            // self.chechPlayingAudio();
            // if (webviewInfo.isInWeixin()) {
            //   setTimeout(() => {
            //     self.chechPlayingAudio();
            //   }, 50);
            // }
            // if (webviewInfo.isInWeixin()) {
            //   setTimeout(() => {
            //     self.chechPlayingVideo();
            //   }, 50);
            // }
          },
          onPlayerReady() {
            clearTimeout(videoTimer);
          }
        }
      });
    },
    // 渲染前修改iframe height
    preFixVideoHeight(richText) {
      const docEl = document.documentElement;
      const standardRetail = docEl.clientWidth / docEl.clientHeight;
      const container = this.$refs.pushContent;
      const containerWidth = container.clientWidth;
      return richText.replace(
        /<iframe/g,
        `<iframe height="${Number.parseInt(containerWidth * standardRetail, 10)}"`
      );
    },
    // 动态生成audio组件
    generateAudioEle() {
      const audioCompArr = Array.from(document.querySelectorAll('.audio-comp'));
      // 生成UI样式及audio 绑定事件
      this.audioCompArr = audioCompArr.map((item, index) => this.generateItem(item, index));
      console.log(this.audioCompArr);
      // this.currentShowAudio = this.audioCompArr[0];
    },
    // 生成音频
    generateItem(dom, index) {
      const exportObj = {
        dom,
        icon: '',
        name: '',
        author: '',
        audio: null,
        isPlaying: false,
        playingTime: '0:00',
        duration: '0:00'
      };
      const name = dom.getAttribute('data-name');
      const author = dom.getAttribute('data-author');
      const src = dom.getAttribute('data-src');
      const icon = dom.getAttribute('data-icon');
      // 赋值导出项
      exportObj.icon = icon;
      exportObj.name = name;
      exportObj.author = author;
      // 创建音频
      const audio = document.createElement('audio');
      audio.preload = 'auto';
      audio.src = src;
      exportObj.audio = audio;
      // 创建歌曲图标 l1
      const audioIcon = document.createElement('div');
      audioIcon.className = 'audio-icon';
      audioIcon.style.background = `url(${icon}) no-repeat center / contain`;
      // 创建控制包裹层 l1
      const audioControlWrap = document.createElement('div');
      audioControlWrap.className = 'audio-control-wrap';
      // 创建歌曲名 l2
      const audioName = document.createElement('div');
      audioName.className = 'audio-name';
      audioName.innerText = name;
      // 创建作者名 l2
      const audioAuthor = document.createElement('div');
      audioAuthor.className = 'audio-author';
      audioAuthor.innerText = author;
      // 创建时间线包裹层 l2
      const audioTimelineWrap = document.createElement('div');
      audioTimelineWrap.className = 'audio-timeline-wrap';
      // 创建底层时间线 l3
      const wholeTimeline = document.createElement('div');
      wholeTimeline.className = 'whole-timeline';
      // 创建上层时间线 l3
      const playedTimeline = document.createElement('div');
      playedTimeline.className = 'played-timeline';
      // 创建播放点包裹 l3
      const dotWrap = document.createElement('div');
      dotWrap.className = 'dot-wrap';
      // 创建下层播放点 l4
      const backDot = document.createElement('div');
      backDot.className = 'back-dot';
      // 创建上层播放点 l4
      const topDot = document.createElement('div');
      topDot.className = 'top-dot';
      // 创建音频播放时间包裹 l3
      const audioTimeWrap = document.createElement('div');
      audioTimeWrap.className = 'audio-time-wrap';
      // 创建播放开始时间 l4
      const playingTime = document.createElement('div');
      playingTime.className = 'playing-time';
      playingTime.innerText = '0:00';
      exportObj.playingTime = '0:00';
      // 创建播放总时间 l4
      const totalTime = document.createElement('div');
      totalTime.className = 'total-time';
      totalTime.innerText = '0:00';
      // 创建播放按钮 l1
      const audioPlayBtn = document.createElement('div');
      audioPlayBtn.className = 'audio-play-btn play-btn';
      // 处理元素层级
      // l4 -> l3
      audioTimeWrap.appendChild(playingTime);
      audioTimeWrap.appendChild(totalTime);
      dotWrap.appendChild(backDot);
      dotWrap.appendChild(topDot);
      // l3 -> l2
      audioTimelineWrap.appendChild(wholeTimeline);
      audioTimelineWrap.appendChild(playedTimeline);
      audioTimelineWrap.appendChild(dotWrap);
      // l2 -> l1
      audioControlWrap.appendChild(audioName);
      audioControlWrap.appendChild(audioAuthor);
      audioControlWrap.appendChild(audioTimelineWrap);
      audioControlWrap.appendChild(audioTimeWrap);
      // l1 -> l0
      dom.appendChild(audioIcon);
      dom.appendChild(audioControlWrap);
      dom.appendChild(audioPlayBtn);
      dom.appendChild(audio);

      // 获取基础属性
      const dotWidth = dotWrap.clientWidth;
      const outerOffsetLeft = dom.offsetLeft;
      const innerOffsetLeft = audioControlWrap.offsetLeft;
      const leftDefault = outerOffsetLeft + innerOffsetLeft;
      const posLimit = leftDefault + audioControlWrap.clientWidth;
      let isPlaying = false;
      exportObj.isPlaying = isPlaying;
      let playingTimeVal = '0:00';

      // audio 监听
      audio.addEventListener('play', () => {
        const audioNameStartIndex = audio.src.lastIndexOf('/');
        const audioNameEndIndex = audio.src.toLowerCase().lastIndexOf('.mp3');
        const audioNameStr = audio.src.substring(audioNameStartIndex + 1, audioNameEndIndex);
        log.log('audio', { other: audioNameStr, type: this.id });
        isPlaying = true;
        exportObj.isPlaying = isPlaying;
        audioPlayBtn.classList.add('pause-btn');
        // this.checkShowHover(index);
        this.chechPlayingVideo();
        this.currentShowAudio = this.audioCompArr[index];
      });
      audio.addEventListener('pause', () => {
        audioPlayBtn.classList.remove('pause-btn');
        isPlaying = false;
        exportObj.isPlaying = false;
        if (this.weaknetTimer) {
          clearTimeout(this.weaknetTimer);
        }
        this.currentShowAudio = null;
      });
      audio.addEventListener('ended', () => {
        isPlaying = false;
        exportObj.isPlaying = isPlaying;
        audioPlayBtn.classList.remove('pause-btn');
        audio.currentTime = 0;
        dotWrap.style.left = `${dotWidth / 2}px`;
        playedTimeline.style.width = `${0}%`;
      });
      audio.addEventListener('durationchange', () => {
        const { duration } = audio;
        if (duration >= 1) {
          totalTime.innerText = this.formatTime(Math.round(duration));
          exportObj.duration = this.formatTime(Math.round(duration));
        }
      });
      audio.addEventListener('timeupdate', () => {
        const { duration } = audio;
        if (duration >= 1) {
          const seek = audio.currentTime || 0;
          playingTime.innerText = this.formatTime(Math.round(seek));
          playingTimeVal = this.formatTime(Math.round(seek));
          exportObj.playingTime = playingTimeVal;
          playedTimeline.style.width = `${(seek / audio.duration) * 100 || 0}%`;
          dotWrap.style.left = `${
            (posLimit - leftDefault) * (seek / audio.duration) - dotWidth / 2
          }px`;
          // 操作悬浮音频
          // if (this.currentShowAudio) {
          // this.$refs.hoveraudio.updateRange(seek / audio.duration);
          // }
        }
      });

      // 相关按钮监听
      audioPlayBtn.addEventListener('click', (e) => {
        if (this.currentAudio && this.currentAudio.index !== index) {
          // dom
          this.currentAudio.dom.classList.remove('pause-btn');
          // audio
          this.currentAudio.audio.pause();
        }
        this.currentAudio = { dom: e.target, index, audio };
        if (e.target.classList.contains('pause-btn')) {
          audio.pause();
          audioPlayBtn.classList.remove('pause-btn');
        } else {
          audio.play();
          audioPlayBtn.classList.add('pause-btn');
          // 添加弱网判断
          this.weaknetTimer = setTimeout(() => {
            if (this.weaknetTimer && exportObj.duration === '0:00') {
              audio.pause();
              toast('网络不好，请稍后重试');
              clearTimeout(this.weaknetTimer);
            }
          }, 10000);
        }
      });
      let percent;
      let startPosX;
      let startposY;
      let dotVal;
      let timelineVal;
      audioControlWrap.addEventListener('touchstart', (e) => {
        startPosX = e.touches[0].clientX;
        startposY = e.touches[0].clientY;
        dotVal = `${e.targetTouches[0].clientX - leftDefault - dotWidth / 2}px`;
        timelineVal = `${e.targetTouches[0].clientX - leftDefault}px`;
        percent = (e.targetTouches[0].clientX - leftDefault) / (posLimit - leftDefault);
      });
      audioControlWrap.addEventListener('touchend', (e) => {
        const endPosX = e.changedTouches[0].clientX;
        const endPosY = e.changedTouches[0].clientY;
        if (
          Math.abs(startPosX - endPosX) < audioControlWrap.clientWidth
          && Math.abs(startposY - endPosY) < dotWidth
        ) {
          if (audio.duration >= 1) {
            dotWrap.style.left = dotVal;
            playedTimeline.style.width = timelineVal;
            // 暂停 seek 播放
            const selfIsPlaying = isPlaying;
            audio.pause();
            audio.currentTime = audio.duration * percent;
            if (selfIsPlaying) audio.play();
          }
        }
      });
      return exportObj;
    },
    // 检查是否该出现小球
    checkShowHover(index) {
      this.currentShowAudio = this.audioCompArr[index];
    },
    // 监听页面滚动
    addPageScrollListener() {
      const pageHeight = window.innerHeight; // 页面高度
      if (webviewInfo.isInAmap()) {
        // const titlebarClientHeight = this.$refs.titlebar.$el.clientHeight; // titlebar高度
        if (this.pageType === 0) {
          const pageTitleHeight = this.$refs.titllCome.$el.clientHeight;
          window.addEventListener('scroll', () => {
            const showObj = this.audioCompArr.find((item) => {
              const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
              return (
                (item.dom.offsetTop + pageTitleHeight - pageHeight > scrollTop
                  || item.dom.offsetTop + pageTitleHeight < scrollTop)
                && item.isPlaying
              );
            });
            this.currentShowAudio = showObj || null;
          });
        } else {
          window.addEventListener('scroll', () => {
            const showObj = this.audioCompArr.find((item) => {
              const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
              return (
                (item.dom.offsetTop - pageHeight > scrollTop || item.dom.offsetTop < scrollTop)
                && item.isPlaying
              );
            });
            this.currentShowAudio = showObj || null;
          });
        }
      } else if (this.pageType === 0) {
        const pageTitleHeight = this.$refs.titllCome.$el.clientHeight;
        window.addEventListener('scroll', () => {
          const showObj = this.audioCompArr.find((item) => {
            const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            return (
              (item.dom.offsetTop + pageTitleHeight - pageHeight > scrollTop
                || item.dom.offsetTop + pageTitleHeight < scrollTop)
              && item.isPlaying
            );
          });
          this.currentShowAudio = showObj || null;
        });
      } else {
        window.addEventListener('scroll', () => {
          const showObj = this.audioCompArr.find((item) => {
            const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            return (
              (item.dom.offsetTop - pageHeight > scrollTop || item.dom.offsetTop < scrollTop)
              && item.isPlaying
            );
          });
          this.currentShowAudio = showObj || null;
        });
      }
    },
    // 检查是否有正在播放的音频并暂停
    chechPlayingAudio() {
      this.audioCompArr.forEach((audio) => {
        if (audio.isPlaying) {
          audio.audio.pause();
        }
      });
    },
    // 检查是否有正在播放的视频并暂停
    chechPlayingVideo() {
      this.videoCompArr.forEach(({ video }) => {
        video.pauseVideo();
      });
    },
    // 增加audio播放事件监听
    addAudioplayListener() {
      document.addEventListener('playevent', () => {
        // 暂停所有视频播放
        this.videoCompArr.forEach(({ video }) => video.pauseVideo());
      });
    },
    // 创建地图元素
    generateMap() {
      const mapEleArr = Array.from(this.$refs.pushContent.querySelectorAll('.map-comp'));
      if (mapEleArr.length) {
        // add 开放平台 script
        window.init = () => {
          this.mapCompArr = mapEleArr.map((mapEle) => {
            const type = mapEle.getAttribute('data-type');
            const tableId = mapEle.getAttribute('data-tableid');
            const name = mapEle.getAttribute('data-name');
            const poiId = mapEle.getAttribute('data-poiId');
            const lng = mapEle.getAttribute('data-lng');
            const lat = mapEle.getAttribute('data-lat');
            return new Map(mapEle, {
              type,
              poi: {
                tableId,
                name,
                poiId,
                lng,
                lat
              }
            });
          });
        };

        this.addScript('https://webapi.amap.com/loader.js',
          () => {
            // eslint-disable-next-line no-undef
            AMapLoader.load({
              key: 'b0c783167a127ada304c5f5dda3d4973',
              version: '1.4.15',
              plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            }).then(() => {
              if (typeof window.init === 'function') {
                window.init();
              }
            }).catch((e) => {
              Monitor.error('地图加载失败');
              console.error(e); // 加载错误提示
            });
          },
          () => {

          });
      }
    },
    addScript(url, onload, onerror) {
      const script = document.createElement('script');
      if (onload) {
        script.onload = () => {
          console.log(111);
          onload(script);
        };
      }
      script.onerror = () => {
        if (onerror) {
          console.log(222);
          onerror(script);
        } else if (onload) {
          console.log(333);
          onload(script);
        }
      };
      script.src = url;
      document.body.appendChild(script);
      return script;
    },
    // 查找下发的图片资源
    getImgArrBindEvent() {
      const imgArr = Array.from(this.$refs.pushContent.querySelectorAll('img'));
      this.imgUrlArr = imgArr.map((img) => img.src);
      imgArr.forEach((img, index) => {
        img.addEventListener('click', () => {
          this.showImgPreview = true;
          this.currentIndex = index;
        });
      });
    },
    // 切换预览图片状态
    handleImgPreviewClose() {
      this.showImgPreview = false;
    },
    // 添加page监听
    addPageListener() {
      window.addEventListener('pagehide', () => {
        if (this.clickTimer) {
          this.clickTimer = false;
          this.audioCompArr.forEach(({ audio }) => {
            audio.pause();
          });
          this.videoCompArr.forEach(({ video }) => {
            video.pauseVideo();
          });
          setTimeout(() => {
            this.clickTimer = true;
          }, 200);
        }
      });
      window.addEventListener('pageshow', () => {
        if (this.clickTimer) {
          // 注册分享按钮
          native.registRightButton('share', '分享', () => {
            log.log('share', { type: this.id });
            // this.share.shareModule(() => {
            //   console.log('分享成功');
            // }, this.shareConfig);
            this.setShare();
          });
          this.clickTimer = false;
          setTimeout(() => {
            this.clickTimer = true;
          }, 200);
        }
      });
      window.addEventListener('touchcancel', () => {
        if (this.clickTimer) {
          this.clickTimer = false;
          this.audioCompArr.forEach(({ audio }) => {
            audio.pause();
          });
          this.videoCompArr.forEach(({ video }) => {
            video.pauseVideo();
          });
          setTimeout(() => {
            this.clickTimer = true;
          }, 200);
        }
      });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState !== 'visible') {
          if (this.clickTimer) {
            this.clickTimer = false;
            this.audioCompArr.forEach(({ audio }) => {
              audio.pause();
            });
            this.videoCompArr.forEach(({ video }) => {
              video.pauseVideo();
            });
            setTimeout(() => {
              this.clickTimer = true;
            }, 200);
          }
        } else if (this.clickTimer) {
          this.clickTimer = false;
          this.audioCompArr.forEach(({ audio }) => {
            audio.pause();
          });
          this.videoCompArr.forEach(({ video }) => {
            video.pauseVideo();
          });
          setTimeout(() => {
            this.clickTimer = true;
          }, 200);
        }
      });
    },
    // 文字图片超链接事件绑定
    bindEvent() {
      let hrefNo = 1;
      [].slice.call(document.querySelectorAll('a'), 0).forEach((item) => {
        // 获取链接
        const iosUrl = item.getAttribute('iosurl');
        const andUrl = item.getAttribute('andurl');
        const insideurl = item.getAttribute('insideurl');
        const outsideurl = item.getAttribute('outsideurl');
        const href = item.getAttribute('href');
        if (iosUrl || andUrl || insideurl || outsideurl || href) {
          item.setAttribute('hrefNo', hrefNo++);
        }
        if (iosUrl || andUrl || insideurl || outsideurl || href) {
          let click = 1;
          item.removeEventListener('click', () => {});
          item.addEventListener(
            'click',
            (e) => {
              // 防连点
              if (click === 0) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              click = 0;
              setTimeout(() => {
                click = 1;
              }, 1000);

              // 跳转
              let schema = false;
              let decodedSchema;
              if (iosUrl && os.ios) {
                decodedSchema = decodeURIComponent(iosUrl);
                if (/^iosamap:/i.test(decodedSchema) || /^amapuri:/i.test(decodedSchema)) {
                  schema = true;
                }
                this.loadUrl(schema, decodedSchema);
              } else if (andUrl && os.android) {
                decodedSchema = decodeURIComponent(andUrl);
                if (/^androidamap:/i.test(decodedSchema) || /^amapuri:/i.test(decodedSchema)) {
                  schema = true;
                }
                this.loadUrl(schema, decodedSchema);
              } else {
                schema = false;
                const url = (webviewInfo.isInAmap() ? insideurl : outsideurl) || href;
                this.loadUrl(schema, url);
              }
              e.preventDefault();
              e.stopPropagation();
            },
            true
          );
        }
      });
    },
    // 跳转schema或url
    loadUrl(isSchema, url) {
      native.destroyRightButton(() => {});
      log.log('url', { other: url, type: this.id });
      setTimeout(() => {
        try {
          if (isSchema) {
            if (webviewInfo.isInAmap()) {
              native.loadSchema(url);
            } else {
              window.location.href = `http://m.autonavi.com/callnative/?schema=${encodeURIComponent(
                url
              )}&title=%E9%AB%98%E5%BE%B7%E5%9C%B0%E5%9B%BE`;
            }
          } else {
            const reg = /^(http:\/\/|https:\/\/)[a-zA-Z0-9]{1}/i;
            if (!reg.test(url)) return;
            window.location.href = url;
            // if (webviewInfo.isInAmap()) {
            //   // locate.pageJump(url);
            //   // native.openAppUrl(url);
            //   window.location.href = url;
            // } else {
            //   const schemaUrl = `${
            //     os.ios ? 'iosamap' : 'androidamap'
            //   }://openFeature?featureName=OpenURL&sa=1&sourceApplication=banner&url=${encodeURIComponent(
            //     url
            //   )}&urlType=0&contentType=autonavi`;
            //   window.location.href = `http://m.autonavi.com/callnative/?schema=${encodeURIComponent(
            //     schemaUrl
            //   )}&title=%E9%AB%98%E5%BE%B7%E5%9C%B0%E5%9B%BE`;
            // }
          }
        } catch (error) {
          throw error;
        }
      }, 200);
    },
    // 设置安卓沉浸态
    setImmersive() {
      if (os.android) {
        immersive.isImmersion().then((height) => {
          if (!height) return;
          this.$refs.contentWrap.style.paddingTop = `${height + 46}px`;
        });
      }
    },
    // 格式化音频时间
    formatTime(secs) {
      const minutes = Math.floor(secs / 60) || 0;
      const seconds = secs - minutes * 60 || 0;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    // 时间埋点
    buryingPoint(logCount = 0) {
      const logTimer = setTimeout(() => {
        if (logCount <= 60) {
          if (logCount === 0) {
            log.log('view_time', { status: logCount, type: this.id });
          } else if (logCount === 5) {
            log.log('view_time', { status: logCount, type: this.id });
          } else if (logCount === 10) {
            log.log('view_time', { status: logCount, type: this.id });
          } else if (logCount === 20) {
            log.log('view_time', { status: logCount, type: this.id });
          } else if (logCount === 30) {
            log.log('view_time', { status: logCount, type: this.id });
          } else if (logCount === 60) {
            log.log('view_time', { status: logCount, type: this.id });
          }
          logCount++;
          this.buryingPoint(logCount);
        } else {
          clearTimeout(logTimer);
        }
      }, 1000);
    },
    // 分享
    setShare() {
      const bodySpmb = document && document.body && document.body.getAttribute('data-spm');
      const share_lastClickSpm = bodySpmb ? `amap.${bodySpmb}.share.share_entrance` : '';
      const share_bid = this.getUuid(this.adiu);
      log.log('act_h5_share_pv', {
        share_from: this.share_from, // 页面pathname
        share_from_type: 'h5',
        share_type: 'url',
        share_lastClickSpm,
      });
      // 新埋点
      if (window.AmapTracker) {
        window.AmapTracker.recordEXP('share_pannel.0', {
          params: {
            share_from: this.share_from, // 页面pathname
            share_from_type: 'h5',
            share_type: 'url',
            share_lastClickSpm,
          }
        });
      }

      const list = ['weixin', 'pengyou', 'dingding', 'weibo'];
      const {
        title, message, imgUrl, url
      } = this.shareConfig;
      const content = list.map((item) => {
        const newUrl = `${url}&share_type=url&share_from_type=h5&share_from=${this.share_from}&share_channel=${item}&share_lastClickSpm=${share_lastClickSpm}&share_bid=${share_bid}`;
        return {
          type: item,
          message,
          shareType: 0,
          title,
          url: newUrl,
          imgUrl
        };
      });
      const shareData = {
        action: 'share',
        content,
        urlType: 0,
        useCustomUrl: 1,
        loadDirectly: 0,
        callbackcase: 1,
        hideMoreBtn: 1, // 为1时不显示更多按钮，为0时或没有该字段时则展示
        hideLinkCopyBtn: 1, // 为1时不显示点击分享此action按钮，为0时或没有该字段时则展示
        pageSpmB: bodySpmb,
        latestClick: {
          spm: share_lastClickSpm
        }
      };
      bridge.send(shareData, (res) => {
        console.log(res);
        const { type } = res || {};
        log.log('act_h5_share_click', {
          share_type: 'url',
          share_from_type: 'h5',
          share_channel: type || 'weibo', // 渠道
          share_from: this.share_from, // 项目名
          share_bid,
          share_lastClickSpm,

        });
        // 新埋点
        if (window.AmapTracker) {
          window.AmapTracker.recordCLK('share_pannel.992', {
            params: {
              share_type: 'url',
              share_from_type: 'h5',
              share_channel: type || 'weibo', // 渠道
              share_from: this.share_from, // 项目名
              share_lastClickSpm,
              share_bid
            }
          });
        }
        console.log('分享成功', res, {
          share_type: 'url',
          share_from_type: 'h5',
          // share_channel: type || 'weibo', // 渠道
          share_from: this.share_from, // 项目名
        });
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../css/index";
@import "../../../common/css/common-mixin";
@import "../css/titleStyle.scss";
html,
body {
  width: 100%;
  height: 100%;
  height: 100vh;
}
#app {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  background: #fff;
  z-index: 1;
  top: 0;
  left: 0;
  position: absolute;
  .content-wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    &.content-out{
      flex: 1;
    }
    &.content-in{
      flex: 1;
    }
    .push-content {
      flex: 1;
      width: 100%;
      & :last-child {
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }
    .preview-mode {
      .img-with-intro,
      p,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      a,
      .video-comp,
      .map-comp {
        padding: 0;
        margin: 0 !important;
      }
      .audio-comp {
        margin: 0;
      }
      .audio-comp .audio-control-wrap {
        width: rpx(360+80);
      }
    }
    .text-mode {
      padding: 0 rpx(40);
    }
    .push-footer {
      width: 100%;
      height: rpx(100);
      // background: url(../../../assets/img/amap-logo.png) no-repeat center /
      //   rpx(158) rpx(52);
      background: url(../../../assets/img/amap-logo.png) no-repeat center /
        rpx(240) rpx(80);
      @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3),
        only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2),
        only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3),
        only screen and (device-width: 360px) and (device-height: 780px) and (-webkit-device-pixel-ratio: 3),
        only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3),
        only screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
        margin-bottom: rpx(70);
      }
    }
  }
  .coupon-pontoon {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: rpx(192);
    background: burlywood;
    .get-coupon-btn {
      width: rpx(185);
      height: rpx(65);
      border-radius: rpx(92);
      font-size: rpx(29.48);
      color: #a02d12;
      font-weight: 700;
      background: #ffe6aa;
      border: none;
      outline: transparent;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.img-with-intro {
  width: 100%;
  margin-bottom: rpx(40);
  img {
    width: 100%;
    margin-bottom: rpx(10);
  }
  .intro {
    text-align: center;
    font-size: rpx(24);
    color: #7f7f7f;
  }
}
.img-inline {
  display: flex;
  justify-content: space-between;
  width: 100%;
  // height: rpx(240);
  display: flex;
  margin-bottom: 0.2rem;
  overflow: hidden;
  .img-wrap-3 {
    display: flex;
    align-items: flex-end;
    width: 32%;
  }
  .img-wrap-preview-3 {
    display: flex;
    align-items: flex-end;
    width: 33.33333%;
  }
  .img-wrap-2 {
    display: flex;
    align-items: flex-end;
    width: 49%;
  }
  .img-wrap-preview-2 {
    display: flex;
    align-items: flex-end;
    width: 50%;
  }
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
p {
  font-size: rpx(28);
  color: #333333;
  // text-align: justify;
  padding-bottom: rpx(40) !important;
  // word-break: break-all;
  // white-space: pre-wrap;
  line-height: rpx(46);
  img {
    max-width: 100%;
    text-align: center;
    margin-bottom: rpx(40);
  }
  img:only-of-type {
    display: block;
    margin: 0 auto;
  }
  & :last-child {
    padding-bottom: 0;
    margin-bottom: 0;
  }
}
a {
  color: #4567e6;
  font-size: rpx(32);
  text-decoration: none;
  word-break: break-all;
  white-space: pre-wrap;
}
a:not(.noLinkIcon)::before {
  display: inline-block;
  content: " ";
  width: rpx(36);
  height: 100%;
  background: url(../../../assets/img/link.png) no-repeat center / rpx(24);
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: rpx(32);
  color: #212121;
  letter-spacing: 1px;
  text-align: justify;
  word-break: break-all;
  white-space: pre-wrap;
}
.audio-comp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: rpx(146);
  border: 2px solid #eef1f8;
  padding: 0 rpx(39) 0 rpx(13);
  margin-bottom: rpx(40);
  background-color: #fff;
  .audio-icon {
    width: rpx(120);
    height: rpx(120);
    border: 1px solid #eef1f8;
    border-radius: 50%;
  }
  .audio-control-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: rpx(360);
    .audio-name {
      font-size: rpx(28);
      height: rpx(36);
      line-height: rpx(36);
      color: #333;
    }
    .audio-author {
      font-size: rpx(20);
      height: rpx(32);
      line-height: rpx(32);
      color: #afafaf;
    }
    .audio-timeline-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: rpx(30);
      .whole-timeline {
        position: absolute;
        width: 100%;
        height: rpx(6);
        background: #e6e6e6;
      }
      .played-timeline {
        position: absolute;
        z-index: 1;
        width: 0;
        height: rpx(6);
        background: #4268e0;
      }
      .dot-wrap {
        position: absolute;
        width: rpx(30);
        height: rpx(8);
        left: rpx(-15);
        .back-dot {
          position: absolute;
          width: rpx(18);
          height: rpx(18);
          top: 50%;
          left: 50%;
          margin-top: rpx(-9);
          margin-left: rpx(-9);
          border-radius: 50%;
          background: #b3c3f3;
          right: 50%;
        }
        .top-dot {
          position: absolute;
          width: rpx(10);
          height: rpx(10);
          top: 50%;
          left: 50%;
          margin-top: rpx(-5);
          margin-left: rpx(-5);
          border-radius: 50%;
          background: #4268e0;
        }
      }
    }
    .audio-time-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #afafaf;
      font-size: rpx(18);
    }
  }
  .audio-play-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: rpx(70);
    height: rpx(70);
    border-radius: 50%;
  }
  .play-btn {
    background: url(../../../assets/img/play-btn.png) no-repeat center / contain;
  }
  .pause-btn {
    background: url(../../../assets/img/pause-btn.png) no-repeat center /
      contain;
  }
}
.video-comp {
  width: 100%;
  margin-bottom: rpx(40);
}
.map-comp {
  width: 100%;
  height: rpx(500);
  margin-bottom: rpx(40);
}
// 天气卡片组件
.weather-box {
  position: relative;
  width: 100%;
  height: rpx(300);
  margin-bottom: rpx(64);
}
.info-scence-window-active {
  display: flex !important;
}
.animation-apear {
  animation: apear 0.3s ease-in-out forwards;
}
@keyframes apear {
  0% {
    top: rpx(-116);
  }
  100% {
    top: 0;
  }
}
.info-scence-window {
  position: absolute;
  top: 0;
  left: rpx(15);
  right: rpx(15);
  height: rpx(116);
  background-color: #fff;
  border-radius: rpx(8);
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.3);
  justify-content: space-between;
  align-items: center;
  padding-right: rpx(24);
  padding-left: rpx(40);
  display: none;
  .title-container {
    max-width: rpx(480);
  }
  .btn {
    width: rpx(162);
    height: rpx(60);
    background-color: #4f94fe;
    border: none;
    color: #fff;
    border-radius: rpx(20);
  }
  .title-common-style {
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .main-title {
    font-size: rpx(25);
    font-weight: bold;
  }
  .sub-title {
    color: #9b9b9b;
    font-size: rpx(22);
    margin-top: rpx(10);
  }
}
</style>
